import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a8cd1f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icons-container" }
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1", -1))
const _hoisted_4 = { class: "circular-image-container" }
const _hoisted_5 = { class: "circular-image-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_8 = { class: "icons" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2", -1))

import {computed} from 'vue'
  import {t} from '@/lib/i18n.js'
  import {useStore} from 'vuex'
  import BigButton from '@/components/inputs/BigButton'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IconsExample',
  setup(__props) {

  const store = useStore()
  const iconText1 = computed(() => t(store, 'chart.icon.1'))
  const iconText2 = computed(() => t(store, 'chart.icon.2'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: require('@/assets/images/spectrogram.jpg'),
            alt: "Spectrogram"
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("p", null, _toDisplayString(_unref(iconText1)), 1)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_unref(BigButton), {
        class: "big-button icons disabled",
        "audio-active": false
      }),
      _createElementVNode("p", null, _toDisplayString(_unref(iconText2)), 1)
    ])
  ]))
}
}

})